import type { BoxResult } from '../types';

export type PlanPackageDimensions = {
  length?: number;
  width?: number;
  height?: number;
};

export type PlanPackage = {
  packageId?: string;
  packageTypeId?: string;
  name?: string;
  dimensions?: PlanPackageDimensions;
  assignedItems?: Array<{ orderItemId?: string; quantity?: number }>;
};

export type PlanItem = {
  fulfillmentPlanItemId?: string;
  salesOrderItemId?: string;
  orderItemId?: string;
  name?: string;
};

export type SellerPackage = {
  packageId?: string;
  name?: string;
};

export const buildBoxesFromPlanPackages = (
  packages: readonly PlanPackage[],
  sellerPackages: readonly SellerPackage[],
  planItems: readonly PlanItem[],
): BoxResult[] => {
  const itemNameById = new Map<string, string>();
  planItems.forEach((item) => {
    if (!item.name) return;
    if (item.fulfillmentPlanItemId) itemNameById.set(item.fulfillmentPlanItemId, item.name);
    if (item.salesOrderItemId) itemNameById.set(item.salesOrderItemId, item.name);
    if (item.orderItemId) itemNameById.set(item.orderItemId, item.name);
  });

  return packages.map((pkg) => {
    const catalogPackage = sellerPackages.find((sp) => sp.packageId === pkg.packageTypeId);
    const itemPositions: NonNullable<BoxResult['itemPositions']> = [];
    (pkg.assignedItems ?? []).forEach((assigned) => {
      const name = (assigned.orderItemId && itemNameById.get(assigned.orderItemId)) || undefined;
      if (!name) return;
      for (let i = 0; i < (assigned.quantity ?? 1); i += 1) {
        itemPositions.push({ x: 0, y: 0, z: 0, item: { name } });
      }
    });

    return {
      box: {
        name: catalogPackage?.name ?? pkg.name ?? '',
        packageId: pkg.packageId,
        length: pkg.dimensions?.length ?? 0,
        width: pkg.dimensions?.width ?? 0,
        height: pkg.dimensions?.height ?? 0,
      },
      itemPositions,
    };
  });
};
